
document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('.evergreen-menu-container');
  const toggleButtons = document.querySelectorAll('#menu-toggle');


  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      sidebar.classList.toggle('active');
    });
  });
});
